import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderMobileOptionsModal = (data) => openPopupHelper({ popupName: popupNames.MOBILE_OPTIONS, data });
